// extracted by mini-css-extract-plugin
export default {"cardsContainer":"cards_cardsContainer__DoIUa"};